import { type ComponentProps, forwardRef } from 'react'

import { isFunction } from 'lodash'

import { delay } from '@subaio/utils'

import { ButtonLoading } from '../ButtonLoading'
import { useLoading } from '../Loading'
import { useStateSafe } from '../useStateSafe'

type Props = {
	isLoading?: boolean
	minDelay?: number

	onClick?: () => Awaitable<any>
	renderLoader?: () => React.JSX.Element
} & Omit<ComponentProps<typeof ButtonLoading>, 'onClick' | 'isVisible' | 'ref'>

export const ButtonAsync = forwardRef<HTMLButtonElement, Props>(
	({ onClick, isLoading: isLoadingManual = false, minDelay = 0, renderLoader, ...props }, ref) => {
		const isLoadingGlobal = useLoading()
		const [isLoadingInternal, setLoadingInternal] = useStateSafe(false)

		return (
			<ButtonLoading
				{...props}
				ref={ref}
				isLoading={isLoadingManual || isLoadingInternal}
				isVisible={!isLoadingGlobal}
				renderLoader={renderLoader}
				onClick={() => {
					if (!onClick) {
						return
					}

					const result = onClick()
					// Is loading state necessary?
					if (minDelay || (result && isFunction(result.then))) {
						setLoadingInternal(true)
						const promiseHandler = () => {
							setLoadingInternal(false)
						}

						// Await both the minimum delay and the promise
						Promise.all([result, delay(minDelay)]).then(promiseHandler, promiseHandler)
					}
				}}
			/>
		)
	},
)
